import React, { FC } from 'react';
import styled from 'styled-components';

export const OnboardingTitle: FC<{
  title: string;
  error?: boolean;
  className?: string;
}> = ({ title, className, error = false }) => {
  return (
    <Title $error={error} className={className}>
      {title}
    </Title>
  );
};

const Title = styled.h1<{ $error: boolean }>`
  font-size: 40px;
  line-height: 1;
  font-weight: 400;
  text-align: center;
  margin-bottom: 12px;
  color: ${({ theme, $error }) =>
    $error ? theme.colors.lightRed : theme.colors.topicBlue};

  ${({ theme }) => theme.breakpoints.down('md')} {
    font-size: 20px;
    font-weight: 700;
    line-height: 30px;
    margin-bottom: 6px;
  }
`;

export const OnboardingSubtitle: FC<{
  subtitle: string;
  error?: boolean;
  className?: string;
}> = ({ subtitle, error = false, className }) => {
  return (
    <Subtitle $error={error} className={className}>
      {subtitle}
    </Subtitle>
  );
};

const Subtitle = styled.h3<{ $error: boolean }>`
  font-size: 20px;
  line-height: 30px;
  font-weight: 300;
  text-align: center;
  color: ${({ theme, $error }) =>
    $error ? theme.colors.lightRed : theme.colors.topicBlue};

  ${({ theme }) => theme.breakpoints.down('md')} {
    font-size: 16px;
    line-height: 21px;
  }
`;
